export default __webpack_public_path__ + "static/media/bg4.927ce467.png";